import axios from 'axios'
import {CADASTRAR_REPASSE_VENDA} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function cadastrarRepasseVenda (repasse) {
  const url = `${URL}/repasse-venda/cadastrar`;
  return dispatch => axios.post(url, repasse, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_REPASSE_VENDA,
        payload: response
      })
  );
}